export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_IS_LOADING_MORE = "SET_IS_LOADING_MORE";
export const SET_NEXT_DATA = "SET_NEXT_DATA";
export const SET_NEW_DATA = "SET_NEW_DATA";
export const SET_HAS_ERROR = "SET_HAS_ERROR";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";

export interface ResponsePayload<TItem> {
  data: TItem[];
  pagination: Pagination;
}

export interface SetLoadMoreResponseAction<TItem> {
  type: typeof SET_NEXT_DATA;
  payload: ResponsePayload<TItem>;
}

export const setLoadMoreResponseAction = <TItem>(
  payload: ResponsePayload<TItem>
): SetLoadMoreResponseAction<TItem> => {
  return {
    payload,
    type: SET_NEXT_DATA,
  };
};

export interface SetLoadNewResponseAction<TItem> {
  type: typeof SET_NEW_DATA;
  payload: ResponsePayload<TItem>;
}

export const setLoadNewResponseAction = <TItem>(
  payload: ResponsePayload<TItem>
): SetLoadNewResponseAction<TItem> => {
  return {
    payload,
    type: SET_NEW_DATA,
  };
};

export interface SetIsLoadingAction {
  type: typeof SET_IS_LOADING;
  payload: boolean;
}

export const setIsLoadingAction = (payload: boolean): SetIsLoadingAction => {
  return {
    payload,
    type: SET_IS_LOADING,
  };
};

export interface SetIsLoadingMoreAction {
  type: typeof SET_IS_LOADING_MORE;
  payload: boolean;
}

export const setIsLoadingMoreAction = (payload: boolean): SetIsLoadingMoreAction => {
  return {
    payload,
    type: SET_IS_LOADING_MORE,
  };
};

export interface SetHasErrorAction {
  type: typeof SET_HAS_ERROR;
  payload: boolean;
}

export const setHasErrorAction = (payload: boolean): SetHasErrorAction => {
  return {
    payload,
    type: SET_HAS_ERROR,
  };
};

export interface SetErrorMessageAction {
  type: typeof SET_ERROR_MESSAGE;
  payload: string;
}

export const setErrorMessageAction = (payload: string): SetErrorMessageAction => {
  return {
    payload,
    type: SET_ERROR_MESSAGE,
  };
};

export type Action<TItem> =
  | SetIsLoadingAction
  | SetIsLoadingMoreAction
  | SetHasErrorAction
  | SetErrorMessageAction
  | SetLoadMoreResponseAction<TItem>
  | SetLoadNewResponseAction<TItem>;
